import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=5798d24c&scoped=true"
import script from "./CustomerTable.vue?vue&type=script&lang=js"
export * from "./CustomerTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerTable.vue?vue&type=style&index=0&id=5798d24c&prod&scoped=true&lang=css"
import style1 from "./CustomerTable.vue?vue&type=style&index=1&id=5798d24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5798d24c",
  null
  
)

export default component.exports